<template>
  <div class="select-offer-modal">
    <AppHeaderV2
      :show-lk="false"
      :show-city-btn="false"
      :disable-sticky="true"
    >
      <template #left>
        <div class="b-nav-bar__panel-btns b-nav-bar__panel-btns--left">
          <c-btn
            disable-style
            :w100="false"
            class="b-nav-bar__panel-btns-item"
            @click="closeModal"
          >
            <div class="b-nav-bar__icon">
              <sprite
                src="sprites_arrow-m-left"
                class="b-nav-bar__icon-sprite b-nav-bar__icon-sprite--stroke"
              />
            </div>
          </c-btn>
        </div>
      </template>
      <template #title>
        Выберите период
      </template>
      <template #right>
        <div class="b-nav-bar__icon" />
      </template>
    </AppHeaderV2>
    <div class="select-offer-subheader">
      <div class="select-offer-subheader__info-block">
        <div class="select-offer-subheader__title">
          <span v-if="isCalories">
            <strong>32&nbsp;000+</strong>
            человек уже похудели с Grow Food.
            В среднем, теряют <strong>6 кг за 2 месяца.</strong>
          </span>
          <span v-else>
            40 000+ человек <strong>улучшили свое здоровье и продуктивность</strong> с Grow Food.
          </span>
        </div>
        <div
          class="select-offer-avatars"
          :class="avatarsClass"
        >
          <div
            v-for="avatar in avatars"
            :key="avatar.id"
            class="select-offer-avatars__item"
          >
            <img
              class="select-offer-avatars__item-img"
              :src="avatar.img"
            >
            <div
              v-if="isCalories"
              class="select-offer-avatars__item-text"
            >
              {{ avatar.text }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="select-offer-modal__cards select-offer-cards">
      <OfferCard
        v-for="mealDay in mealDaysSort"
        :key="mealDay.title"
        class="select-offer-card"
        :title="mealDay.title"
        :offer-sub-text="mealDay.offerSubText"
        :day-price-full="mealDay.dayPriceFull"
        :day-price="mealDay.dayPrice"
        :discount="mealDay.discount"
        :cashback="mealDay.cashback?.name"
        :is-active="mealDay.title === selectedMealDay?.title"
        @click="selectMealDay(mealDay)"
      />
    </div>
    <div
      v-if="selectedMealDay.numberOfMealDays === 2 && numberOfMealsFull"
      key="days-2"
      class="select-offer-modal__payment-info"
    >
      <p>Лучший способ начать питаться с Grow&nbsp;Food.</p>
      <p>
        {{ $numberLingFormWithNumberFunc(numberOfMealsFull, 'блюдо', 'блюда', 'блюд') }}
        на&nbsp;{{ $numberLingFormWithNumberFunc(selectedMealDay.numberOfMealDays, 'день', 'дня', 'дней') }} из популярной линейки питания.
      </p>
    </div>
    <div
      v-else-if="!selectedMealDay.subscriptionDays"
      key="days-6-12"
      class="select-offer-modal__payment-info"
    >
      <div
        v-if="permanentSubscription.price"
        class="select-offer-modal__subscription-switcher"
      >
        <div class="select-offer-modal__subscription-text">
          <p class="select-offer-modal__subscription-title">
            Подписка
            <span
              v-if="permanentSubscriptionDiscount"
              class="select-offer-modal__subscription-discount"
            >-{{ permanentSubscriptionDiscount }}%</span>
          </p>
          <p
            v-if="permanentSubscriptionDescription"
            class="select-offer-modal__subscription-description"
          >
            {{ permanentSubscriptionDescription }}
          </p>
        </div>
        <CoreSwitcher
          :value="isPermanentSubscriptionChecked"
          @toggle="togglePermanentSubscription"
        />
      </div>
      <p v-else>
        Оптимальная продолжительность, чтобы попробовать формат питания с Grow Food.
      </p>
    </div>
    <div
      v-else
      key="days-30-60"
      class="select-offer-modal__payment-info"
    >
      <p>
        <strong>
          Оплата списывается частями еженедельно
        </strong>
      </p>
      <p>
        По окончании периода предложим продлить.<br>Отключить можно в любое время.
      </p>
    </div>
    <div class="select-offer-modal__btn-section">
      <CoreButton
        w100
        class="select-offer-modal-btn"
        :class="selectOfferModalBtnClasses"
        type="from-var"
        :loading="isLoading"
        @click="onButtonClick"
      >
        Оплатить&nbsp;
        <span class="select-offer-modal-btn__right">
          {{ selectedMealDay.dayPrice }}&nbsp;₽ в день
        </span>
        <transition
          name="fade"
          duration="150"
        >
          <Image
            v-if="isDiscountOffer"
            class="select-offer-modal-btn__label"
            src="@/assets/images/offer-images/persent-icon.svg"
          />
        </transition>
      </CoreButton>
    </div>
  </div>
</template>
<script>
import { reverse } from 'lodash'

import { ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
// components
import CoreButton from '@/components/core/ui/CoreButton'
import CoreSwitcher from '@/components/core/ui/CoreSwitcher'
import AppHeaderV2 from '@/components/landing/AppHeaderV2'
import OfferCard from '@/components/core/ui/OfferCard'
// constants
import { CosmeticDiscount } from '@/config/constants'

const offersText = {
  60: 'Измени себя',
  30: 'Почувствуй эффект',
  12: 'Попробуй Grow Food x2',
  6: 'Попробуй Grow Food',
  2: 'Начни с малого',
}

const avatarsInfo = [
  {
    id: 1,
    sort: 2,
    img: require('@/assets/images/offer-images/1.png'),
    text: '-7 кг',
  },
  {
    id: 6,
    sort: 5,
    img: require('@/assets/images/offer-images/2.png'),
    text: '-5 кг',
  },
  {
    id: 3,
    sort: 5,
    img: require('@/assets/images/offer-images/3.png'),
    text: '-12 кг',
  },
  {
    id: 4,
    sort: 4,
    img: require('@/assets/images/offer-images/4.jpeg'),
    text: '-5 кг',
  },
  {
    id: 5,
    sort: 3,
    img: require('@/assets/images/offer-images/5.jpeg'),
    text: '-9 кг',
  },
  {
    id: 1,
    sort: 2,
    img: require('@/assets/images/offer-images/6.png'),
    text: '-5 кг',
  },
]

export default {
  components: {
    AppHeaderV2,
    CoreButton,
    CoreSwitcher,
    OfferCard,
  },
  props: {
    numberOfMeals: {
      type: [Number, null],
      default: null,
    },
    mealDays: {
      type: Array,
      required: true,
    },
    isEconomTariffPage: {
      type: Boolean,
      default: false,
    },
    isCalories: {
      type: Boolean,
      default: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    selectedMenuType: {
      type: [String, null],
      default: null,
    },
    firstDeliveryDiscountEnabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'close',
    'select',
    'buttonClick',
  ],
  setup (
    props,
    // comtext
    {
      emit,
    },
  ) {
    const closeModal = () => {
      emit('close')
    }
    const selectedMealDay = ref(null)
    const isPermanentSubscriptionChecked = ref(false)

    const selectMealDay = (mealDay) => {
      selectedMealDay.value = mealDay
      emit('select', selectedMealDay.value)
    }

    const getDiscountText = (mealDay, realDays) => {
      let discountText = ''
      const firstOrderDiscount = mealDay.promoInfo.benefitValues?.find((benefit) => {
        return benefit.type === 'firstorderpercent'
      })
      const discount = mealDay.promoInfo.discounts?.find((discount) => {
        return discount.discountType === 'percent'
      })
      const benefitDiscount = mealDay.promoInfo.benefitValues?.find((benefit) => {
        return benefit.type === 'percent'
      })

      if (discount?.discountValue) {
        discountText = `Скидка ${Math.floor(discount.discountValue)}%`
      }

      if (benefitDiscount && firstOrderDiscount && discount) {
        discountText = discountText + `, ${benefitDiscount.name}`.toLowerCase()
      }

      if (!discountText && mealDay.shouldShowDiscount) {
        discountText = getCosmeticDiscount(mealDay)
      }

      return discountText
    }

    const store = useStore()

    const mealDaysSort = computed(() => {
      const mealDaysSort = props.mealDays.map((mealDay) => {
        let dayPrice = mealDay.promoInfo.dayPrice
        let dayPriceFull = mealDay.fullPrice / mealDay.numberOfMealDays
        let realDays = mealDay.numberOfMealDays

        if (mealDay?.subscriptionDays) {
          dayPriceFull = Math.round(mealDay.fullPrice / mealDay.subscriptionDays)
          realDays = mealDay.subscriptionDays
        }

        const discount = getDiscountText(mealDay, realDays)
        const offerSubText = offersText[realDays]

        let fullEconomy = null
        if (mealDay.subscriptionDays) {
          fullEconomy = mealDay.promoInfo.benefit
        }
        if (isPermanentSubscriptionVisible(mealDay)) {
          fullEconomy = mealDay.permanentSubscription?.fullEconomy
          dayPrice = mealDay.permanentSubscription?.price || mealDay.promoInfo.dayPrice
        }

        const shouldShowDiscount = mealDay.promoInfo.discounts?.length > 0 || mealDay.promoInfo.benefitValues?.length > 0

        const cashback = mealDay.promoInfo.benefitValues?.find((benefit) => {
          return benefit.benefitType === 'cashback_percent_base'
        })

        return {
          ...mealDay,
          dayPrice,
          dayPriceFull,
          offerSubText,
          fullEconomy,
          discount,
          shouldShowDiscount,
          cashback,
        }
      })
      return reverse(mealDaysSort)
    })

    const avatars = computed(() => {
      if (props.isCalories) {
        const a = [...avatarsInfo]
        a.pop()
        return a
      }
      return avatarsInfo.sort((a, b) => a.sort < b.sort)
    })
    const isFirstOrderDiscountOffer = computed(() => {
      return !!firstOrderDiscount.value
    })
    const firstOrderDiscount = computed(() => {
      return selectedMealDay.value?.promoInfo?.benefitValues?.find((benefit) => {
        return benefit.type === 'firstorderpercent'
      })
    })
    const isDiscountOffer = computed(() => {
      if (selectedMealDay.value) {
        const persentDiscount = selectedMealDay.value.promoInfo.discounts.find((discount) => {
          return discount.discountType === 'percent'
        })
        if (persentDiscount && persentDiscount.discountValue >= 50) {
          return true
        }
        return isFirstOrderDiscountOffer.value
      }
      return false
    })
    const numberOfMealsFull = computed(() => {
      if (!props.numberOfMeals && !selectedMealDay.value) {
        return false
      }
      return props.numberOfMeals * selectedMealDay.value.numberOfMealDays
    })

    const avatarsClass = computed(() => {
      return {
        'select-offer-avatars--calories': props.isCalories,
      }
    })

    const permanentSubscription = computed(() => {
      return selectedMealDay.value.permanentSubscription || {}
    })

    const permanentSubscriptionDiscount = computed(() => {
      return permanentSubscription.value.discountValue
    })

    const permanentSubscriptionDescription = computed(() => {
      return permanentSubscription.value.description
    })

    const isPermanentSubscriptionVisible = (mealDay) => {
      return mealDay.numberOfMealDays === 6 && !mealDay.subscriptionId_H && isPermanentSubscriptionChecked.value
    }

    const togglePermanentSubscription = (isChecked) => {
      isPermanentSubscriptionChecked.value = isChecked
      store.dispatch('analytics/sendStandardMarkupEvent', {
        block: 'new_order',
        element: 'subscription_switch',
        action: isChecked ? 'on' : 'off',
      })
    }

    const getCosmeticDiscount = (mealDay) => {
      const discountValue = CosmeticDiscount[mealDay.numberOfMealDays]
      if (discountValue) {
        return `Скидка ${discountValue}%`
      }
      return ''
    }

    onMounted(() => {
      selectedMealDay.value = mealDaysSort.value[0]
      // selectedMealDay.value = mealDaysSort.value.find((mealDay) => mealDay.isDefault) || mealDaysSort.value[0]
      emit('select', selectedMealDay.value)
    })
    const onButtonClick = () => {
      emit('buttonClick', isPermanentSubscriptionChecked.value)
    }
    const selectOfferModalBtnClasses = computed(() => {
      return {
        'select-offer-modal-btn--loading': props.isLoading,
      }
    })
    return {
      avatars,
      mealDaysSort,
      selectedMealDay,
      selectMealDay,
      isFirstDeliveryDiscountOffer: isFirstOrderDiscountOffer,
      isDiscountOffer,
      onButtonClick,
      numberOfMealsFull,
      avatarsClass,
      closeModal,
      permanentSubscription,
      permanentSubscriptionDiscount,
      permanentSubscriptionDescription,
      isPermanentSubscriptionChecked,
      togglePermanentSubscription,
      selectOfferModalBtnClasses,
    }
  },
}
</script>

<style lang="scss">
$hightlight: #C8EB1E;
$secondary: #0F4128;
.select-offer-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  height: 100vh;
  width: 100vw;
  max-width: 100vw;
  min-height: 100vh;
  background: map-get($colors, 'white');
  font-size: 24px;
  overflow: scroll;
  display: flex;
  flex-direction: column;
  &__cards {
    margin-bottom: auto;
  }
  &__payment-info {
    padding: 8px 24px;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
    color: map-get($colors, 'grey_60');
    strong {
      font-weight: 600;
      color: map-get($colors, 'black');
    }
  }
  &__btn-section {
    margin: 8px 16px 96px;
  }
  &__promo-info{
    margin-top: 10px;
    text-align: center;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    color: #FA414B;
  }
  &__subscription-switcher {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }
  &__subscription-text {
    text-align: left;
    max-width: 220px;
  }
  &__subscription-title {
    display: flex;
    align-items: center;
    gap: 7px;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: -0.32px;
    color: map-get($colors, 'black');
    margin-bottom: 2px;
  }
  &__subscription-discount {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 16px;
    padding: 0 6px;
    border-radius: 11px;
    background-color: map-get($colors, 'main_red_error');
    color: map-get($colors, 'white');
    font-size: 10px;
    line-height: 12px;
    letter-spacing: 0.5px;
  }

  &__subscription-description {
    color: map-get($colors, 'grey_60');
    font-size: 12px;
    line-height: 16px;
  }
}
.select-offer-modal-btn {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  &--loading  {
    justify-content: center;
  }
  &__right {
    margin-left: auto;
    text-align: left;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 1px;
  }
  &__label {
    position: absolute;
    top: -6px;
    right: -6px;
    width: 20px;
    height: 20px;
  }
}
.select-offer-subheader {
  padding: 16px 16px 52px;
  background: url('~@/assets/images/patterns/gf-pattern.svg');
  background-repeat: repeat-x;
  background-position: bottom left;
  background-color: var(--bg-color, $hightlight);
  &__info-block {
    min-height: 100px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }
  &__title {
    margin-bottom: 16px;
    color: $secondary;
    text-align: center;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.15px;
    strong {
      font-weight: 600;
      color: map-get($colors, 'black');
    }
  }
}
.select-offer-avatars {
  $self: &;
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: center;
  &__item {
    position: relative;
    width: 40px;
    height: 40px;
    margin-right: -6px;
  }
  &__item-img {
    width: 100%;
    height: 100%;
    border-radius: 50px;
    border: 2px solid var(--bg-color, $hightlight);
    object-fit: cover;
  }
  &__item-text {
    position: absolute;
    bottom: -5px;
    left: 18px;
    padding: 2px 4px;
    width: max-content;
    border-radius: 50px;
    border: 2px solid var(--bg-color, $hightlight);
    background: var(--bg-color--secondary, $secondary);
    color: map-get($colors, 'white');
    font-weight: 600;
    font-size: 8px;
    line-height: 8px;
  }
  &--calories {
    #{$self} {
      &__item {
        margin-right: 16px;
      }
      &__item-img {
        border-width: 0px;
      }
    }
  }
}
.select-offer-cards {
  padding: 12px 16px;
}
.select-offer-card {
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
}

</style>
